import { render, staticRenderFns } from "./QuickstartMiniStepForm.vue?vue&type=template&id=e5023d6c&scoped=true&"
import script from "./QuickstartMiniStepForm.vue?vue&type=script&lang=js&"
export * from "./QuickstartMiniStepForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5023d6c",
  null
  
)

export default component.exports